import {css} from 'lit';
export const styles = css`:host(ef-dot-menu) .trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    width: var(--dot-menu-trigger-width, 28px);
    max-width: 28px;
    max-width: var(--dot-menu-trigger-width, 28px);
    height: 28px;
    height: var(--dot-menu-trigger-height, 28px);
    padding: 0;
    background-color: transparent;
    background-color: var(--dot-menu-trigger-bg, transparent);
    border: none;
    border: var(--dot-menu-trigger-border, none);
    border-radius: 0;
    border-radius: var(--dot-menu-trigger-radius, 0);
    color: var(--dark-text);
    color: var(--dot-menu-trigger-color, var(--dark-text));
    font-size: 22px;
    font-size: var(--dot-menu-trigger-font-size, 22px);
    overflow: hidden;
    transition: all var(--transition-timing) var(--transition-duration);
    transition: var(
      --dot-menu-trigger-transition,
      all var(--transition-timing) var(--transition-duration)
    );
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
  }

    @media (hover: hover) {
      :host(ef-dot-menu) .trigger:hover {
        --dot-menu-trigger-bg: var(--dot-menu-trigger-bg-hover);
        --dot-menu-trigger-color: var(--dot-menu-trigger-color-hover);
      }
    }

    :host(ef-dot-menu) .trigger.focus-visible {
      outline: 1px solid
        var(--link-focus-outline);
      outline: 1px solid
        var(--dot-menu-trigger-focus-outline, var(--link-focus-outline));
      outline-offset: var(--dot-menu-trigger-focus-outline-offset);
    }

    :host(ef-dot-menu) .trigger.focus-visible {
      outline: 1px solid
        var(--link-focus-outline);
      outline: 1px solid
        var(--dot-menu-trigger-focus-outline, var(--link-focus-outline));
      outline-offset: var(--dot-menu-trigger-focus-outline-offset);
    }

    :host(ef-dot-menu) .trigger:focus-visible {
      outline: 1px solid
        var(--link-focus-outline);
      outline: 1px solid
        var(--dot-menu-trigger-focus-outline, var(--link-focus-outline));
      outline-offset: var(--dot-menu-trigger-focus-outline-offset);
    }

    :host(ef-dot-menu) .trigger:active {
      --dot-menu-trigger-bg: var(--dot-menu-trigger-bg-active);
      --dot-menu-trigger-color: var(--dot-menu-trigger-color-active);
    }
.xs-title-1 ef-icon-block,
.xs-title-2 ef-icon-block,
.xs-title-3 ef-icon-block,
.xs-title-4 ef-icon-block {
  --icon-font-size-primary: 1.15em;
}
.xs-title-1 ef-dot-menu,
.xs-title-1 ef-dot-menu-2,
.xs-title-2 ef-dot-menu,
.xs-title-2 ef-dot-menu-2,
.xs-title-3 ef-dot-menu,
.xs-title-3 ef-dot-menu-2,
.xs-title-4 ef-dot-menu,
.xs-title-4 ef-dot-menu-2 {
  display: inline-block;
  margin-left: 4px;
}
.xs-title-1 {
  margin-top: 26px;
  margin-bottom: 32px;
  font-size: var(--font-size-xl);
}
.xs-title-1 ef-icon-block {
    --font-size-primary: var(--font-size-xl);
  }
.xs-title-2 {
  margin-top: 26px;
  margin-bottom: 16px;
  font-size: var(--font-size-lg);
}
.xs-title-2 ef-icon-block {
    --font-size-primary: var(--font-size-lg);
  }
.xs-title-3 {
  margin-top: 26px;
  margin-bottom: 8px;
  font-size: var(--font-size-md);
}
.xs-title-3 ef-icon-block {
    --font-size-primary: var(--font-size-md);
  }
.xs-title-4 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: var(--font-size-base);
}
.xs-title-4 ef-icon-block {
    --font-size-primary: var(--font-size-base);
  }
.xs-title-1:first-child,
.xs-title-2:first-child,
.xs-title-3:first-child,
.xs-title-4:first-child {
  margin-top: 0;
}
.xs-short-lg,
.xs-short-md,
.xs-short-sm {
  color: var(--dark-text-secondary);
}
.xs-short-lg a ef-avatar, .xs-short-md a ef-avatar, .xs-short-sm a ef-avatar {
      display: inline-flex;
    }
.xs-short-lg {
  font-size: calc(var(--font-size-base) * 1.062); /* ~ 17px */
}
.xs-short-md {
  font-size: var(--font-size-base); /* ~ 16px */
}
.xs-short-sm {
  font-size: var(--font-size-sm); /* ~ 14px */
}
@media (min-width: 768px) {
  .xs-title-1,
  .xs-title-2,
  .xs-title-3 {
    margin-top: 32px;
  }
}
.xs-btn {
  --btn-padding-x: 1rem;
  --btn-padding-y: 0.375rem;
  --btn-font-size: var(--font-size-base);
  --btn-font-weight: 700;
  --btn-line-height: 1.5;
  --btn-color: var(--dark-text);
  --btn-bg: transparent;
  --btn-border-width: 2px;
  --btn-border-color: transparent;
  --btn-border-radius: 6px;
  --btn-hover-border-color: transparent;
  --btn-disabled-opacity: 0.65;

  display: inline-block;
  padding: var(--btn-padding-y) var(--btn-padding-x);
  font-size: var(--btn-font-size);
  font-weight: var(--btn-font-weight);
  line-height: var(--btn-line-height);
  color: var(--btn-color);
  text-align: center;
  text-decoration: none;
  font-style: normal;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  border: var(--btn-border-width) solid var(--btn-border-color);
  border-radius: var(--btn-border-radius);
  background-color: var(--btn-bg);
  -webkit-hyphens: auto;
          hyphens: auto;
}
.btn-primary {
  --btn-color: var(--light-text);
  --btn-bg: var(--primary-500);
  --btn-border-color: var(--primary-500);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--primary-600);
  --btn-hover-border-color: var(--primary-700);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--primary-700);
  --btn-active-border-color: var(--primary-800);
  --btn-disabled-color: var(--light-text);
  --btn-disabled-bg: var(--primary-500);
  --btn-disabled-border-color: var(--primary-500);
}
.btn-secondary {
  --btn-color: var(--dark-text);
  --btn-bg: var(--secondary-400);
  --btn-border-color: var(--secondary-400);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--secondary-500);
  --btn-hover-border-color: var(--secondary-600);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--secondary-600);
  --btn-active-border-color: var(--secondary-700);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--secondary-400);
  --btn-disabled-border-color: var(--secondary-400);
}
.btn-success {
  --btn-color: var(--dark-text);
  --btn-bg: var(--success-500);
  --btn-border-color: var(--success-500);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--success-600);
  --btn-hover-border-color: var(--success-700);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--success-700);
  --btn-active-border-color: var(--success-800);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--success-500);
  --btn-disabled-border-color: var(--success-500);
}
.btn-info {
  --btn-color: var(--dark-text);
  --btn-bg: var(--info-500);
  --btn-border-color: var(--info-500);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--info-600);
  --btn-hover-border-color: var(--info-700);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--info-700);
  --btn-active-border-color: var(--info-800);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--info-500);
  --btn-disabled-border-color: var(--info-500);
}
.btn-warning {
  --btn-color: var(--dark-text);
  --btn-bg: var(--warning-500);
  --btn-border-color: var(--warning-500);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--warning-600);
  --btn-hover-border-color: var(--warning-700);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--warning-700);
  --btn-active-border-color: var(--warning-800);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--warning-500);
  --btn-disabled-border-color: var(--warning-500);
}
.btn-danger {
  --btn-color: var(--light-text);
  --btn-bg: var(--danger-400);
  --btn-border-color: var(--danger-400);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--danger-500);
  --btn-hover-border-color: var(--danger-600);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--danger-600);
  --btn-active-border-color: var(--danger-700);
  --btn-disabled-color: var(--light-text);
  --btn-disabled-bg: var(--danger-400);
  --btn-disabled-border-color: var(--danger-400);
}
.btn-dark {
  --btn-color: var(--light-text);
  --btn-bg: var(--gray-900);
  --btn-border-color: var(--gray-900);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--gray-700);
  --btn-hover-border-color: var(--gray-900);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--gray-800);
  --btn-active-border-color: var(--gray-900);
  --btn-disabled-color: var(--light-text);
  --btn-disabled-bg: var(--gray-900);
  --btn-disabled-border-color: var(--gray-900);
}
.btn-light {
  --btn-color: var(--dark-text);
  --btn-bg: var(--gray-100);
  --btn-border-color: var(--gray-100);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--gray-300);
  --btn-hover-border-color: var(--gray-400);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--gray-400);
  --btn-active-border-color: var(--gray-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-100);
  --btn-disabled-border-color: var(--gray-100);
}
.btn-contrast-light {
  --btn-color: var(--dark-text);
  --btn-bg: var(--contrast-light);
  --btn-border-color: var(--contrast-light);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--gray-200);
  --btn-hover-border-color: var(--gray-400);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--gray-300);
  --btn-active-border-color: var(--gray-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-000);
  --btn-disabled-border-color: var(--gray-100);
}
.btn-outline-primary {
  --btn-color: var(--primary-text);
  --btn-border-color: var(--primary-500);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--primary-500);
  --btn-hover-border-color: var(--primary-700);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--primary-600);
  --btn-active-border-color: var(--primary-700);
  --btn-disabled-color: var(--primary-400);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--primary-400);
}
.btn-outline-secondary {
  --btn-color: var(--secondary-text);
  --btn-border-color: var(--secondary-500);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--secondary-500);
  --btn-hover-border-color: var(--secondary-700);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--secondary-600);
  --btn-active-border-color: var(--secondary-700);
  --btn-disabled-color: var(--secondary-400);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--secondary-400);
}
.btn-outline-info {
  --btn-color: var(--info-text);
  --btn-border-color: var(--info-500);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--info-500);
  --btn-hover-border-color: var(--info-700);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--info-600);
  --btn-active-border-color: var(--info-700);
  --btn-disabled-color: var(--info-400);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--info-400);
}
.btn-outline-success {
  --btn-color: var(--success-text);
  --btn-border-color: var(--success-500);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--success-500);
  --btn-hover-border-color: var(--success-700);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--success-600);
  --btn-active-border-color: var(--success-700);
  --btn-disabled-color: var(--success-400);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--success-400);
}
.btn-outline-warning {
  --btn-color: var(--warning-text);
  --btn-border-color: var(--warning-500);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--warning-500);
  --btn-hover-border-color: var(--warning-700);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--warning-600);
  --btn-active-border-color: var(--warning-700);
  --btn-disabled-color: var(--warning-400);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--warning-400);
}
.btn-outline-danger {
  --btn-color: var(--danger-text);
  --btn-border-color: var(--danger-400);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--danger-400);
  --btn-hover-border-color: var(--danger-600);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--danger-500);
  --btn-active-border-color: var(--danger-600);
  --btn-disabled-color: var(--danger-400);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--danger-400);
}
.btn-outline-light {
  --btn-color: var(--light-text);
  --btn-border-color: var(--gray-100);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--gray-200);
  --btn-hover-border-color: var(--gray-300);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--gray-300);
  --btn-active-border-color: var(--gray-400);
  --btn-disabled-color: var(--gray-200);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-300);
}
.btn-outline-dark {
  --btn-color: var(--dark-text);
  --btn-border-color: var(--gray-900);
  --btn-hover-color: var(--light-text);
  --btn-hover-bg: var(--gray-700);
  --btn-hover-border-color: var(--gray-900);
  --btn-active-color: var(--light-text);
  --btn-active-bg: var(--gray-600);
  --btn-active-border-color: var(--gray-800);
  --btn-disabled-color: var(--gray-700);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}
/* Sizes */
.xs-btn-sm {
  --btn-padding-y: 0.25rem;
  --btn-padding-x: 0.5rem;
  --btn-font-size: var(--font-size-sm);
  --btn-border-radius: 6px;
}
.xs-btn-lg {
  --btn-padding-y: 0.5rem;
  --btn-padding-x: 2rem;
  --btn-font-size: var(--font-size-lg);
  --btn-border-radius: 6px;
}
/* States */
.xs-btn:hover {
  color: var(--btn-hover-color);
  background-color: var(--btn-hover-bg);
  border-color: var(--btn-hover-border-color);
}
.xs-btn:active {
  color: var(--btn-active-color);
  background-color: var(--btn-active-bg);
  border-color: var(--btn-active-border-color);
}
.xs-btn.disabled,
.xs-btn:disabled,
fieldset:disabled .xs-btn {
  color: var(--btn-disabled-color);
  pointer-events: none;
  background-color: var(--btn-disabled-bg);
  border-color: var(--btn-disabled-border-color);
  opacity: var(--btn-disabled-opacity);
}
[data-theme='dark'] .btn-primary,
[data-theme='dark'] .btn-secondary,
[data-theme='dark'] .btn-info,
[data-theme='dark'] .btn-success,
[data-theme='dark'] .btn-warning,
[data-theme='dark'] .btn-danger {
  --btn-color: var(--light-text);
  --btn-active-color: var(--light-text);
  --btn-hover-color: var(--light-text);
}
.xs-btn ef-icon.suffix {
  margin-left: 4px;
}
.xs-btn ef-icon.prefix {
  margin-right: 4px;
}
.xs-btn ef-icon {
  font-size: inherit;
}
@media (max-width: 575px) {
.btn-block-xs {
    display: block;
    width: 100%
}
  }
@media (min-width: 576px) and (max-width: 767px) {
.btn-block-sm {
    display: block;
    width: 100%
}
  }
@media (min-width: 768px) and (max-width: 991px) {
.btn-block-md {
    display: block;
    width: 100%
}
  }
@media (min-width: 992px) and (max-width: 1199px) {
.btn-block-lg {
    display: block;
    width: 100%
}
  }
@media (min-width: 1200px) and (max-width: 1399px) {
.btn-block-xl {
    display: block;
    width: 100%
}
  }
.btn-block {
  display: block;
  width: 100%;
}
/*** DEFAULT RESETS ***/
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin: 0;
  outline: none;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  opacity: 1; /* <-- Force native arrows on number input in Chrome to be always visible without focus/hover. Like Firefox or Safari */
}
select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}
fieldset:not(:first-child) {
  margin-top: 40px;
}
fieldset:not(:last-child) {
  margin-bottom: 40px;
}
/*** LABEL ***/
.label-control {
  display: inline-block;
  margin-bottom: 0.5rem;
  color: var(--label-color);
  font-weight: var(--label-font-weight);
}
.label-control abbr {
    text-decoration: none;
  }
/*** INPUTS (all without radio and check type) ***/
.input-control {
  width: 100%;
  height: var(--input-height);
  padding: var(--input-padding);
  font-size: var(--input-font-size);
  line-height: var(--input-line-height);
  color: var(--input-color);
  background-color: var(--input-bg);
  background-clip: padding-box;
  border: var(--input-border-width) var(--input-border-style)
    var(--input-border);
  border-radius: var(--input-border-radius);
  font-weight: var(--input-font-weight);
  transition: border-color var(--transition-timing) var(--transition-duration);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
/* Input type number does not support size attribute (except Firefox)
     so we are adding it manually (e.g. card form => options => priority field) */
.input-control[type='number'][size='2'] {
    width: 74px;
  }
.input-control[type='number'][size='3'] {
    width: 86px;
  }
.input-control[type='number'][size='4'] {
    width: 92px;
  }
.input-control[type='number'][size='5'] {
    width: 100px;
  }
.input-control[type='number'][size='6'] {
    width: 114px;
  }
.input-control.medium-editor-element {
    height: auto;
    min-height: 100px;
  }
.input-control.input-control-sm {
    height: var(--input-height-sm);
    padding: var(--input-padding-sm);
    font-size: var(--input-font-size-sm);
  }
.input-control::-moz-placeholder {
    opacity: 1; /* Because of some browsers render with opacity */
  }
.input-control::placeholder,
  .input-control:disabled {
    opacity: 1; /* Because of some browsers render with opacity */
  }
.input-control::-moz-placeholder {
    color: var(--input-placeholder-color);
    font-weight: 400;
  }
.input-control::placeholder {
    color: var(--input-placeholder-color);
    font-weight: 400;
  }
.input-control:focus {
    outline: none;
    box-shadow: var(--input-box-shadow);
  }
select.input-control,
.as-select .input-control {
  padding-right: 42px;
  background-image: linear-gradient(
      45deg,
      transparent 50%,
      var(--gray-500) 50% calc(50% + 1px),
      transparent calc(50% + 2px)
    ),
    linear-gradient(
      -45deg,
      transparent 50%,
      var(--gray-500) 50% calc(50% + 1px),
      transparent calc(50% + 2px)
    );
  background-position: right 24px top 50%, right 16px top 50%;
  background-size: 8px 8px;
  background-repeat: no-repeat;
}
select.input-control.input-control-sm, .as-select .input-control.input-control-sm {
    padding-right: 34px;
    background-image: linear-gradient(
        45deg,
        transparent 50%,
        var(--gray-500) 50% calc(50% + 1px),
        transparent calc(50% + 2px)
      ),
      linear-gradient(
        -45deg,
        transparent 50%,
        var(--gray-500) 50% calc(50% + 1px),
        transparent calc(50% + 2px)
      );
    background-position: right 20px top 51%, right 12px top 51%;
  }
textarea.input-control {
  min-height: 100px;
  resize: vertical;
}
/*** RADIO & CHECKBOX ***/
.check-control {
  position: absolute !important;
  left: -9999px !important;
}
.check-control.focus-visible + label {
    outline: 1px solid var(--focus-color);
    outline-offset: 4px;
  }
.check-control:focus-visible + label {
    outline: 1px solid var(--focus-color);
    outline-offset: 4px;
  }
.check-control + label {
    position: relative;
    display: inline;
    color: var(--input-color);
    font-weight: 700;
  }
.check-control + label::before,
  .check-control + label::after {
    position: absolute;
    top: 1px;
    left: -32px;
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
.check-control + label::before {
    content: '';
    border: 2px solid var(--input-check-color);
    border-radius: 4px;
  }
.check-control + label::after {
    content: '\\f00c';
    margin-top: 1px;
    font-family: var(--icon);
    color: var(--input-check-color);
    text-align: center;
    font-size: 12px;
    opacity: 0;
  }
.check-control[type='radio'] + label::before {
    border-radius: 50%;
  }
.check-control:checked + label::after {
    opacity: 1;
  }
.check-control.focus-visible + label::before {
    box-shadow: var(--input-box-shadow);
  }
.check-control:focus-visible + label::before {
    box-shadow: var(--input-box-shadow);
  }
.radio {
  display: block;
}
.radio .input-hint {
    font-weight: 400;
  }
.radio + .radio {
    margin-top: 16px;
  }
/*** HINT ***/
.input-hint {
  margin-bottom: 8px;
  color: var(--input-hint-color);
  font-size: var(--font-size-sm);
}
/*** ERROR MSG ***/
.input-msg {
  margin-top: 6px;
  font-size: var(--font-size-sm);
}
/* TODO: Improve with-label style */
.with-label {
  position: relative;
}
.with-label ef-label {
  position: absolute;
  right: var(--input-border-width);
  top: var(--input-border-width);
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
}
/*** INPUT CONTROL WRAPPERS (Date, Time, Currency) ***/
.control-wrapper {
  position: relative;
}
.control-wrapper::after {
    position: absolute;
    display: block;
    right: 16px;
    top: 50%;
    padding: 4px;
    background-color: var(--input-bg);
    font-family: var(--icon);
    transform: translateY(-50%);
    pointer-events: none;
  }
.control-wrapper.date::after {
    content: '\\f783';
    font-size: 16px;
  }
.control-wrapper.time::after {
    content: '\\f017';
    font-size: 16px;
  }
.control-wrapper.eur::after {
    content: 'EUR';
    font-size: 16px;
    font-family: var(--font-family);
  }
.control-wrapper.chf::after {
    content: 'CHF';
    font-size: 16px;
    font-family: var(--font-family);
  }
/*** FORM GROUP ***/
.xs-form-group {
  position: relative;
  margin-bottom: 20px;
}
.xs-form-group:last-child {
    margin-bottom: 0;
  }
.xs-form-group.xs-form-group-boolean {
    padding-left: 32px;
  }
.xs-form-group.xs-form-group-boolean .input-hint {
      margin-top: 8px;
      margin-bottom: 0;
    }
.xs-form-group.disabled .input-control,
    .xs-form-group.disabled .check-control + label {
      opacity: 0.7;
      cursor: not-allowed;
    }
/*** FORM GROUP INVALID ***/
.xs-form-group.invalid {
  --label-color: var(--input-error-color);

  color: var(--input-error-color);
}
.xs-form-group.invalid .input-control {
    border-color: var(--input-error-border);
  }
.xs-form-group.invalid .input-control:focus {
    box-shadow: var(--input-error-box-shadow);
  }
.xs-form-group.invalid .check-control + label::before {
    border-color: var(--input-error-border);
  }
.xs-form-group.invalid .check-control + label::after {
    color: var(--input-error-color);
  }
.xs-form-group.invalid .check-control:focus + label::before {
    box-shadow: var(--input-error-box-shadow);
  }
.xs-form-group.invalid .check-control + label {
    color: var(--input-error-color);
  }
/*** OVERRIDES ***/
ef-grid-list .xs-form-group {
    margin-bottom: 0;
  }
/*** Touch devices ***/
@media (hover: none) {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
            appearance: none; /* Hide native arrows from input */
  }
    .input-control[type='number'] {
      -webkit-appearance: textfield;
         -moz-appearance: textfield;
              appearance: textfield; /* Hide native arrows from input */
    }

    .input-control[type='number'][size='2'] {
      width: 53px;
    }

    .input-control[type='number'][size='3'] {
      width: 61px;
    }

    .input-control[type='number'][size='4'] {
      width: 70px;
    }

    .input-control[type='number'][size='5'] {
      width: 79px;
    }

    .input-control[type='number'][size='6'] {
      width: 89px;
    }
}
.button-icon {
  --bg-hover: var(--gray-300);
  --bg-active: var(--gray-400);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background-color: transparent;
  color: inherit;
  font-size: var(--font-size-lg);
  line-height: 1;
}
@media (hover: hover) {
  .button-icon:hover {
    background-color: var(--bg-hover);
    color: inherit;
  }
}
.button-icon:active {
  background-color: var(--bg-active);
  color: inherit;
}
.button-icon.focus-visible {
  outline-offset: 0;
}
.button-icon:focus-visible {
  outline-offset: 0;
}
ef-list-item-10.v1 {
  background-color: var(--contrast-light);
  font-size: var(--font-size-sm);
  color: var(--dark-text);
  padding: 0;
}
ef-list-item-10.v1 [slot='left'] {
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.857em;
  background-color: var(--gray-200);
  border-radius: 6px;
  margin-right: 16px;
}
ef-list-item-10.v1 > .title {
  margin: 0;
  font-weight: 700;
  font-size: 1em;
}
ef-list-item-10.v1 .info {
  color: var(--dark-text-secondary);
}
@media (hover: hover) {
  a:hover > ef-list-item-10.v1 {
    color: var(--link-text-hover);
  }
}
a:active > ef-list-item-10.v1 {
  color: var(--dark-text-secondary);
}
/*** V2 - Section header ***/
ef-list-item-10.v2 {
  background-color: transparent;
}
ef-list-item-10.v2 [slot='left'] {
  --avatar-size: 40px;

  margin: 0;
}
ef-list-item-10.v2 ef-icon[slot='left'] {
  font-size: 25px;
}
ef-list-item-10.v2 [slot='main'] {
  margin-left: 8px;
  font-size: var(--font-size-base);
  font-weight: 700;
}
ef-list-item-10.v2 .info > div:nth-child(2) {
  color: var(--dark-text-secondary);
  font-weight: 400;
  font-size: var(--font-size-sm);
}
/* 🟡🟡🟡 WARNING 🟡🟡🟡 */
/* Do NOT edit helpers.css file as it is auto generated from editing helpers.scss  */
/* Run "npm run sass:watch" to auto generate .css files from .sass files */
/* 🟡🟡🟡 WARNING 🟡🟡🟡 */
/* Margins & paddings */
.mt-0 {
  margin-top: 0 !important;
}
.mt-1 {
  margin-top: 4px !important;
}
.mt-2 {
  margin-top: 8px !important;
}
.mt-3 {
  margin-top: 16px !important;
}
.mt-4 {
  margin-top: 32px !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.mr-1 {
  margin-right: 4px !important;
}
.mr-2 {
  margin-right: 8px !important;
}
.mr-3 {
  margin-right: 16px !important;
}
.mr-4 {
  margin-right: 32px !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.mb-1 {
  margin-bottom: 4px !important;
}
.mb-2 {
  margin-bottom: 8px !important;
}
.mb-3 {
  margin-bottom: 16px !important;
}
.mb-4 {
  margin-bottom: 32px !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.ml-1 {
  margin-left: 4px !important;
}
.ml-2 {
  margin-left: 8px !important;
}
.ml-3 {
  margin-left: 16px !important;
}
.ml-4 {
  margin-left: 32px !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pt-1 {
  padding-top: 4px !important;
}
.pt-2 {
  padding-top: 8px !important;
}
.pt-3 {
  padding-top: 16px !important;
}
.pt-4 {
  padding-top: 32px !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.pr-1 {
  padding-right: 4px !important;
}
.pr-2 {
  padding-right: 8px !important;
}
.pr-3 {
  padding-right: 16px !important;
}
.pr-4 {
  padding-right: 32px !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pb-1 {
  padding-bottom: 4px !important;
}
.pb-2 {
  padding-bottom: 8px !important;
}
.pb-3 {
  padding-bottom: 16px !important;
}
.pb-4 {
  padding-bottom: 32px !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pl-1 {
  padding-left: 4px !important;
}
.pl-2 {
  padding-left: 8px !important;
}
.pl-3 {
  padding-left: 16px !important;
}
.pl-4 {
  padding-left: 32px !important;
}
@media (min-width: 576px) {
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 4px !important;
  }
  .mt-sm-2 {
    margin-top: 8px !important;
  }
  .mt-sm-3 {
    margin-top: 16px !important;
  }
  .mt-sm-4 {
    margin-top: 32px !important;
  }
  .mr-sm-0 {
    margin-right: 0 !important;
  }
  .mr-sm-1 {
    margin-right: 4px !important;
  }
  .mr-sm-2 {
    margin-right: 8px !important;
  }
  .mr-sm-3 {
    margin-right: 16px !important;
  }
  .mr-sm-4 {
    margin-right: 32px !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 4px !important;
  }
  .mb-sm-2 {
    margin-bottom: 8px !important;
  }
  .mb-sm-3 {
    margin-bottom: 16px !important;
  }
  .mb-sm-4 {
    margin-bottom: 32px !important;
  }
  .ml-sm-0 {
    margin-left: 0 !important;
  }
  .ml-sm-1 {
    margin-left: 4px !important;
  }
  .ml-sm-2 {
    margin-left: 8px !important;
  }
  .ml-sm-3 {
    margin-left: 16px !important;
  }
  .ml-sm-4 {
    margin-left: 32px !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 4px !important;
  }
  .pt-sm-2 {
    padding-top: 8px !important;
  }
  .pt-sm-3 {
    padding-top: 16px !important;
  }
  .pt-sm-4 {
    padding-top: 32px !important;
  }
  .pr-sm-0 {
    padding-right: 0 !important;
  }
  .pr-sm-1 {
    padding-right: 4px !important;
  }
  .pr-sm-2 {
    padding-right: 8px !important;
  }
  .pr-sm-3 {
    padding-right: 16px !important;
  }
  .pr-sm-4 {
    padding-right: 32px !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 4px !important;
  }
  .pb-sm-2 {
    padding-bottom: 8px !important;
  }
  .pb-sm-3 {
    padding-bottom: 16px !important;
  }
  .pb-sm-4 {
    padding-bottom: 32px !important;
  }
  .pl-sm-0 {
    padding-left: 0 !important;
  }
  .pl-sm-1 {
    padding-left: 4px !important;
  }
  .pl-sm-2 {
    padding-left: 8px !important;
  }
  .pl-sm-3 {
    padding-left: 16px !important;
  }
  .pl-sm-4 {
    padding-left: 32px !important;
  }
}
@media (min-width: 768px) {
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 4px !important;
  }
  .mt-md-2 {
    margin-top: 8px !important;
  }
  .mt-md-3 {
    margin-top: 16px !important;
  }
  .mt-md-4 {
    margin-top: 32px !important;
  }
  .mr-md-0 {
    margin-right: 0 !important;
  }
  .mr-md-1 {
    margin-right: 4px !important;
  }
  .mr-md-2 {
    margin-right: 8px !important;
  }
  .mr-md-3 {
    margin-right: 16px !important;
  }
  .mr-md-4 {
    margin-right: 32px !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 4px !important;
  }
  .mb-md-2 {
    margin-bottom: 8px !important;
  }
  .mb-md-3 {
    margin-bottom: 16px !important;
  }
  .mb-md-4 {
    margin-bottom: 32px !important;
  }
  .ml-md-0 {
    margin-left: 0 !important;
  }
  .ml-md-1 {
    margin-left: 4px !important;
  }
  .ml-md-2 {
    margin-left: 8px !important;
  }
  .ml-md-3 {
    margin-left: 16px !important;
  }
  .ml-md-4 {
    margin-left: 32px !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 4px !important;
  }
  .pt-md-2 {
    padding-top: 8px !important;
  }
  .pt-md-3 {
    padding-top: 16px !important;
  }
  .pt-md-4 {
    padding-top: 32px !important;
  }
  .pr-md-0 {
    padding-right: 0 !important;
  }
  .pr-md-1 {
    padding-right: 4px !important;
  }
  .pr-md-2 {
    padding-right: 8px !important;
  }
  .pr-md-3 {
    padding-right: 16px !important;
  }
  .pr-md-4 {
    padding-right: 32px !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 4px !important;
  }
  .pb-md-2 {
    padding-bottom: 8px !important;
  }
  .pb-md-3 {
    padding-bottom: 16px !important;
  }
  .pb-md-4 {
    padding-bottom: 32px !important;
  }
  .pl-md-0 {
    padding-left: 0 !important;
  }
  .pl-md-1 {
    padding-left: 4px !important;
  }
  .pl-md-2 {
    padding-left: 8px !important;
  }
  .pl-md-3 {
    padding-left: 16px !important;
  }
  .pl-md-4 {
    padding-left: 32px !important;
  }
}
@media (min-width: 992px) {
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 4px !important;
  }
  .mt-lg-2 {
    margin-top: 8px !important;
  }
  .mt-lg-3 {
    margin-top: 16px !important;
  }
  .mt-lg-4 {
    margin-top: 32px !important;
  }
  .mr-lg-0 {
    margin-right: 0 !important;
  }
  .mr-lg-1 {
    margin-right: 4px !important;
  }
  .mr-lg-2 {
    margin-right: 8px !important;
  }
  .mr-lg-3 {
    margin-right: 16px !important;
  }
  .mr-lg-4 {
    margin-right: 32px !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 4px !important;
  }
  .mb-lg-2 {
    margin-bottom: 8px !important;
  }
  .mb-lg-3 {
    margin-bottom: 16px !important;
  }
  .mb-lg-4 {
    margin-bottom: 32px !important;
  }
  .ml-lg-0 {
    margin-left: 0 !important;
  }
  .ml-lg-1 {
    margin-left: 4px !important;
  }
  .ml-lg-2 {
    margin-left: 8px !important;
  }
  .ml-lg-3 {
    margin-left: 16px !important;
  }
  .ml-lg-4 {
    margin-left: 32px !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 4px !important;
  }
  .pt-lg-2 {
    padding-top: 8px !important;
  }
  .pt-lg-3 {
    padding-top: 16px !important;
  }
  .pt-lg-4 {
    padding-top: 32px !important;
  }
  .pr-lg-0 {
    padding-right: 0 !important;
  }
  .pr-lg-1 {
    padding-right: 4px !important;
  }
  .pr-lg-2 {
    padding-right: 8px !important;
  }
  .pr-lg-3 {
    padding-right: 16px !important;
  }
  .pr-lg-4 {
    padding-right: 32px !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 4px !important;
  }
  .pb-lg-2 {
    padding-bottom: 8px !important;
  }
  .pb-lg-3 {
    padding-bottom: 16px !important;
  }
  .pb-lg-4 {
    padding-bottom: 32px !important;
  }
  .pl-lg-0 {
    padding-left: 0 !important;
  }
  .pl-lg-1 {
    padding-left: 4px !important;
  }
  .pl-lg-2 {
    padding-left: 8px !important;
  }
  .pl-lg-3 {
    padding-left: 16px !important;
  }
  .pl-lg-4 {
    padding-left: 32px !important;
  }
}
@media (min-width: 1200px) {
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 4px !important;
  }
  .mt-xl-2 {
    margin-top: 8px !important;
  }
  .mt-xl-3 {
    margin-top: 16px !important;
  }
  .mt-xl-4 {
    margin-top: 32px !important;
  }
  .mr-xl-0 {
    margin-right: 0 !important;
  }
  .mr-xl-1 {
    margin-right: 4px !important;
  }
  .mr-xl-2 {
    margin-right: 8px !important;
  }
  .mr-xl-3 {
    margin-right: 16px !important;
  }
  .mr-xl-4 {
    margin-right: 32px !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 4px !important;
  }
  .mb-xl-2 {
    margin-bottom: 8px !important;
  }
  .mb-xl-3 {
    margin-bottom: 16px !important;
  }
  .mb-xl-4 {
    margin-bottom: 32px !important;
  }
  .ml-xl-0 {
    margin-left: 0 !important;
  }
  .ml-xl-1 {
    margin-left: 4px !important;
  }
  .ml-xl-2 {
    margin-left: 8px !important;
  }
  .ml-xl-3 {
    margin-left: 16px !important;
  }
  .ml-xl-4 {
    margin-left: 32px !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 4px !important;
  }
  .pt-xl-2 {
    padding-top: 8px !important;
  }
  .pt-xl-3 {
    padding-top: 16px !important;
  }
  .pt-xl-4 {
    padding-top: 32px !important;
  }
  .pr-xl-0 {
    padding-right: 0 !important;
  }
  .pr-xl-1 {
    padding-right: 4px !important;
  }
  .pr-xl-2 {
    padding-right: 8px !important;
  }
  .pr-xl-3 {
    padding-right: 16px !important;
  }
  .pr-xl-4 {
    padding-right: 32px !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 4px !important;
  }
  .pb-xl-2 {
    padding-bottom: 8px !important;
  }
  .pb-xl-3 {
    padding-bottom: 16px !important;
  }
  .pb-xl-4 {
    padding-bottom: 32px !important;
  }
  .pl-xl-0 {
    padding-left: 0 !important;
  }
  .pl-xl-1 {
    padding-left: 4px !important;
  }
  .pl-xl-2 {
    padding-left: 8px !important;
  }
  .pl-xl-3 {
    padding-left: 16px !important;
  }
  .pl-xl-4 {
    padding-left: 32px !important;
  }
}
@media (min-width: 1400px) {
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 4px !important;
  }
  .mt-xxl-2 {
    margin-top: 8px !important;
  }
  .mt-xxl-3 {
    margin-top: 16px !important;
  }
  .mt-xxl-4 {
    margin-top: 32px !important;
  }
  .mr-xxl-0 {
    margin-right: 0 !important;
  }
  .mr-xxl-1 {
    margin-right: 4px !important;
  }
  .mr-xxl-2 {
    margin-right: 8px !important;
  }
  .mr-xxl-3 {
    margin-right: 16px !important;
  }
  .mr-xxl-4 {
    margin-right: 32px !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 4px !important;
  }
  .mb-xxl-2 {
    margin-bottom: 8px !important;
  }
  .mb-xxl-3 {
    margin-bottom: 16px !important;
  }
  .mb-xxl-4 {
    margin-bottom: 32px !important;
  }
  .ml-xxl-0 {
    margin-left: 0 !important;
  }
  .ml-xxl-1 {
    margin-left: 4px !important;
  }
  .ml-xxl-2 {
    margin-left: 8px !important;
  }
  .ml-xxl-3 {
    margin-left: 16px !important;
  }
  .ml-xxl-4 {
    margin-left: 32px !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 4px !important;
  }
  .pt-xxl-2 {
    padding-top: 8px !important;
  }
  .pt-xxl-3 {
    padding-top: 16px !important;
  }
  .pt-xxl-4 {
    padding-top: 32px !important;
  }
  .pr-xxl-0 {
    padding-right: 0 !important;
  }
  .pr-xxl-1 {
    padding-right: 4px !important;
  }
  .pr-xxl-2 {
    padding-right: 8px !important;
  }
  .pr-xxl-3 {
    padding-right: 16px !important;
  }
  .pr-xxl-4 {
    padding-right: 32px !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 4px !important;
  }
  .pb-xxl-2 {
    padding-bottom: 8px !important;
  }
  .pb-xxl-3 {
    padding-bottom: 16px !important;
  }
  .pb-xxl-4 {
    padding-bottom: 32px !important;
  }
  .pl-xxl-0 {
    padding-left: 0 !important;
  }
  .pl-xxl-1 {
    padding-left: 4px !important;
  }
  .pl-xxl-2 {
    padding-left: 8px !important;
  }
  .pl-xxl-3 {
    padding-left: 16px !important;
  }
  .pl-xxl-4 {
    padding-left: 32px !important;
  }
}
.big {
  font-size: 1.15em;
}
.small {
  font-size: 0.85em;
}
/* Contextual backgrounds */
.primary-bg {
  background-color: var(--primary-bg);
}
.success-bg {
  background-color: var(--success-bg);
}
.info-bg {
  background-color: var(--info-bg);
}
.warning-bg {
  background-color: var(--warning-bg);
}
.danger-bg {
  background-color: var(--danger-bg);
}
.light-bg {
  background-color: var(--light-bg);
}
.dark-bg {
  background-color: var(--dark-bg);
}
/* Contextual colors */
.primary-text {
  color: var(--primary-text);
}
.success-text {
  color: var(--success-text);
}
.info-text {
  color: var(--info-text);
}
.warning-text {
  color: var(--warning-text);
}
.danger-text {
  color: var(--danger-text);
}
.light-text {
  color: var(--light-text);
}
.dark-text {
  color: var(--dark-text);
}
button.primary-link,
button.success-link,
button.info-link,
button.warning-link,
button.danger-link,
button.light-link,
button.dark-link {
  padding: 0;
  background: transparent;
  border: transparent;
  color: var(--link-text);
  font-weight: 700;
}
@media (hover: hover) {
  button.primary-link:hover,
  button.success-link:hover,
  button.info-link:hover,
  button.warning-link:hover,
  button.danger-link:hover,
  button.light-link:hover,
  button.dark-link:hover {
    color: var(--link-text-hover);
  }
}
button.primary-link:active,
button.success-link:active,
button.info-link:active,
button.warning-link:active,
button.danger-link:active,
button.light-link:active,
button.dark-link:active {
  color: var(--link-text-active);
}
.primary-link {
  --link-text: var(--primary-400);
  --link-text-hover: var(--primary-700);
  --link-text-active: var(--primary-300);
}
.success-link {
  --link-text: var(--success-400);
  --link-text-hover: var(--success-700);
  --link-text-active: var(--success-300);
}
.info-link {
  --link-text: var(--info-400);
  --link-text-hover: var(--info-700);
  --link-text-active: var(--info-300);
}
.warning-link {
  --link-text: var(--warning-400);
  --link-text-hover: var(--warning-700);
  --link-text-active: var(--warning-300);
}
.danger-link {
  --link-text: var(--danger-400);
  --link-text-hover: var(--danger-700);
  --link-text-active: var(--danger-300);
}
.light-link {
  --link-text: var(--light-text);
  --link-text-hover: var(--gray-400);
  --link-text-active: var(--gray-200);
}
.dark-link {
  --link-text: var(--dark-text);
}
.switcher {
  --background: var(--contrast-light);

  display: flex;
  background-color: var(--background);
  padding: 4px;
  border-radius: var(--border-radius);
}
.switcher ef-badge {
    outline: 1px solid var(--contrast-light);
    margin-left: 4px;
  }
.switcher > * {
  flex: 1;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
  border: none;
  overflow: hidden;
  text-overflow: ellipsis;
}
.switcher > *:not(:last-child) {
  margin-right: 4px;
}
sl-tab-group {
  --track-width: 0;
}
sl-tab-group::part(nav) {
    background-color: var(--contrast-light);
    border-radius: var(--border-radius);
  }
sl-tab-group::part(tabs) {
    width: 100%;
  }
sl-tab {
  --tab-display: flex;
  --tab-justify-content: center;
  --tab-padding: 10px;
  --tab-color: var(--body-text);
  --tab-color-hover: var(--tab-color);
  --tab-color-active: var(--tab-color);
  --tab-border-radius: var(--border-radius);

  flex: 1 1 auto;
  max-width: 80%;
  padding: 4px;
  background-color: var(--contrast-light);
}
@media (hover: hover) {
    sl-tab:hover {
      --tab-background: var(--gray-200);
    }
  }
sl-tab:active {
    --tab-background: var(--gray-300);
  }
sl-tab > * {
    text-overflow: ellipsis;
    overflow: hidden;
  }
sl-tab > .prefix,
  sl-tab > .suffix {
    display: inline-flex;
    flex: 0 0 auto;
  }
sl-tab:first-of-type {
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
}
sl-tab:not(:first-of-type) {
  margin-left: -4px;
}
sl-tab:last-of-type {
  border-top-right-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}
sl-tab[active]:not([disabled]) {
  --tab-background: var(--primary);
  --tab-color: var(--contrast-light);
}
sl-tab[active]:not([disabled]):active {
    --tab-background: var(--primary-600);
  }
sl-tab[active] {
  max-width: none;
}
sl-tab:only-of-type {
  max-width: 80%;
}
`;
export default styles;
